import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserOut } from '@/api/auth';

interface AuthState {
  token: string | null;
  user: UserOut | null;
  login: (token: string, user: UserOut) => void;
  setUser: (user: UserOut) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      login: (token, user) => set({ token, user }),
      setUser: (user) => set({ user }),
      logout: () => set({ token: null, user: null })
    }),
    { name: 'bow-auth' }
  )
);
